import * as React from "react";
function SvgIcChevronSmallDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.38 10L12 12.634 16.62 10l.38.649-5 2.852-5-2.852.38-.649z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronSmallDown;
